import { React, useState, useEffect, useMemo, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Box, Typography, CircularProgress } from "@mui/material";
import CustomizedTable from "../../CustomizedTable/CustomizedTable";
import { DefaultCell, TitleCaseCell } from "../../CustomizedTable/CustomCells/CustomCells";
import DateTimeRangeCell from "../../CustomizedTable/CustomCells/DateTimeRangeCell/DateTimeRangeCell";
import MilesCell from "../../CustomizedTable/CustomCells/MilesCell/MilesCell";
import CallinStatusCell from "../../CustomizedTable/CustomCells/CallinStatusCell/CallinStatusCell";
import DateRangeFilter from "../../CustomizedTable/Filters/DateRangeFilter/DateRangeFilter";
import NumberRangeFilter from "../../CustomizedTable/Filters/NumberRangeFilter/NumberRangeFilter";
import MultiOptionsFilter from "../../CustomizedTable/Filters/MultipleOptionsFilter/MultipleOptionsFilter";
import CallinStatusFilter from "../../CustomizedTable/Filters/CallinStatusFilter/CallinStatusFilter";
import { sortArrayOfDateObjectsDesc } from "../../../utils/sortHelpers";
import { AlertContext } from "../../Dashboard/Dashboard";
import { CarrierService } from "../../../services/CarrierService";

export default function LoadProfileCallins({
  activeLoad,
}) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [isLoading, setIsLoading] = useState(false);
  const [loadCallins, setLoadCallins] = useState([]);

  const callins = useMemo(() => loadCallins, [loadCallins]);

  const columns = useMemo(
    () => [
      {
        Header: "Call Date & Time",
        accessor: "callDateTime",
        Filter: DateRangeFilter,
        filter: "dateBetween",
        width: 150,
        Cell: DateTimeRangeCell,
      },
      {
        Header: "City",
        accessor: "city",
        filter: "fuzzyText",
        width: 100,
        Cell: TitleCaseCell,
      },
      {
        Header: "State",
        accessor: "state",
        Filter: MultiOptionsFilter,
        filter: "multi",
        width: 80,
        Cell: DefaultCell,
      },
      {
        Header: "Entered by User",
        accessor: "enteredByUser",
        filter: "fuzzyText",
        width: 140,
        Cell: DefaultCell,
      },
      {
        Header: "Status",
        accessor: "callinStatus",
        Filter: CallinStatusFilter,
        filter: "multi",
        width: 150,
        Cell: CallinStatusCell,
      },
      {
        Header: "Next Stop City",
        accessor: "nextStopCity",
        filter: "fuzzyText",
        width: 130,
        Cell: TitleCaseCell,
      },
      {
        Header: "Next Stop State",
        accessor: "nextStopState",
        Filter: MultiOptionsFilter,
        filter: "multi",
        width: 140,
        Cell: DefaultCell,
      },
      {
        Header: "ETA to Next Stop",
        accessor: "newEta",
        Filter: DateRangeFilter,
        filter: "dateBetween",
        width: 150,
        Cell: DateTimeRangeCell,
      },
      {
        Header: "Distance to Next Stop",
        accessor: "distanceNextStop",
        Filter: NumberRangeFilter,
        filter: "between",
        width: 170,
        Cell: MilesCell,
      },
      {
        Header: "Comments",
        accessor: "comments",
        filter: "fuzzyText",
        width: 800,
        Cell: DefaultCell,
      },
    ],
    []
  );

  const getLoadCallins = () => {
    if (activeLoad.id) {
      setIsLoading(true);
      CarrierService.GetCallInsByOrder(instance, activeLoad.id).then(res => {
        let orderedCallins = sortArrayOfDateObjectsDesc(res.callins, "callDateTime");
        if (orderedCallins.length > 0) orderedCallins.forEach(callin => {
          callin.enteredByUser = callin.comments?.includes("MacroPoint") ? "MacroPoint" : callin.comments?.includes("Text Locate") ? "Text Locate" : callin.enteredBy;
        });
        setLoadCallins(orderedCallins);
        setIsLoading(false);
      }).catch(error => {
        console.error(error);
        setIsLoading(false);
        warning(error);
      });
    }
  };

  useEffect(() => {
    if (activeLoad) {
      getLoadCallins();
    }
  }, [activeLoad]);

  return (
    <Box className="Load-profile-component">
      <Box className="Load-profile-component-header">
        <Typography variant="h3" color="black_opacity.100">
          Tracking
        </Typography>
      </Box>
      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
          <CircularProgress sx={{ color: "primary.60" }} size={40} />
        </Box>
      ) : (
        <CustomizedTable
          id="load-profile-callins"
          columns={columns}
          data={callins}
        />
      )}
    </Box>
  );
}

LoadProfileCallins.propTypes = {
  activeLoad: PropTypes.object.isRequired,
};